import "./TakeawayCartModal.scss";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import { addItemToCart, removeItemFromCart } from "../../../../redux/cart/reducer";
import EmptyCart from "../../../../components/lotties/emptyCart";
import Lottie from "lottie-react";
import {
  BeersArray,
  CocktailsArray,
  FoodArray,
  HotDrinksArray,
  OtherArray,
  SoftsArray,
  WineArray,
  CategoriesArray,
} from "../../../../utility/data";
import { Icons } from "../../../../images/icons";
import { MinusIcon, PlusIcon } from "../../../../components/Icon";

const TakeawayCartModal = ({
  open,
  setOpen,
  total,
  setTotal,
  setCareModalOpen,
  setPaymentModalOpen,
}) => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const cartStore = useSelector((state) => state.cartReducer.cartByOrg[orgId] || []);
  const { t } = useTranslation("takeaway");

  return (
    <Modal onHide={setOpen} show={open} centered className="takeaway-cart-modal">
      <Modal.Body>
        <div className="header-section">
          <h2 className="title">{t("cart")}</h2>
        </div>

        {cartStore.length > 0 ? (
          <div className="content-section">
            <div className="content-section-items">
              {cartStore.map((item) => (
                <CashlessItem
                  cart={cartStore}
                  add={(item) => {
                    setTotal((prev) => prev + parseFloat(item.price));
                    dispatch(addItemToCart({ orgId, item }));
                  }}
                  remove={(item) => {
                    setTotal((prev) => prev - parseFloat(item.price));
                    dispatch(removeItemFromCart({ orgId, item }));
                  }}
                  key={item.id}
                  item={item}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="content-section-empty-cart">
            <Lottie animationData={EmptyCart} className="content-section-empty-cart-lottie" />
          </div>
        )}

        <div className="footer-section">
          <div className="price-container">
            <p className="total-price">{t("total")}</p>
            <p className="price"> {total.toFixed(2)}€</p>
          </div>

          <div className="buttons-container">
            <GradientButton onPress={() => setOpen(false)}>{t("back")}</GradientButton>
            <GradientButton
              onPress={() => {
                if (total < 1) {
                  setOpen(false);
                  setCareModalOpen(true);
                } else {
                  setPaymentModalOpen(true);
                  setOpen(false);
                }
              }}
            >
              {t("confirm")}
            </GradientButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
const CashlessItem = ({ item, setNewdata, cart, add, remove }) => {
  const prdIndex = cart.find((prd) => prd.id === item.id);

  const iconArrays = {
    Food: { array: FoodArray, default: Icons.food },
    Softs: { array: SoftsArray, default: Icons.soft },
    Beers: { array: BeersArray, default: Icons.beer },
    Cocktails: { array: CocktailsArray, default: Icons.cocktail },
    Wine: { array: WineArray, default: Icons.wine },
    "Hot drinks": { array: HotDrinksArray, default: Icons.drink },
    Other: { array: OtherArray, default: Icons.others },
    default: { array: CategoriesArray, default: Icons.others },
  };

  const getImageSrc = (item) => {
    const category = item?.category;
    const iconData = iconArrays[category] || iconArrays.default;

    if (item?.customIcon && item.customIcon !== "") {
      return iconData.array.find((i) => i.name === item.customIcon)?.icon || iconData.default;
    } else {
      return iconData.default;
    }
  };

  return (
    <div className="takeaway-item">
      <div className="img-content-group">
        <div className="img">
          <img src={getImageSrc(item)} alt="item" />
        </div>
        <div className="content">
          <p className="subtext">{item.subtitle}</p>
          <h3 className="subtitle">{item.title}</h3>
          <div className="price">
            <span>x{prdIndex ? prdIndex.quantity : "0"}</span>
            <span style={{ color: "#27AE60" }}>{(item.price * 1).toFixed(2)}€</span>
          </div>
        </div>
      </div>
      <div className="button-group">
        <button onClick={() => add(item)}>
          <PlusIcon />
        </button>
        <div className="divider"></div>
        <button type="button" onClick={() => remove(item)}>
          <MinusIcon />
        </button>
      </div>
    </div>
  );
};

export default TakeawayCartModal;
